/* tslint:disable */
/* eslint-disable */
/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MessageFilter } from '../models';
// @ts-ignore
import { MessagePostPut } from '../models';
// @ts-ignore
import { MessageTemplateDto } from '../models';
// @ts-ignore
import { ServiceProviderCaseMessage } from '../models';
// @ts-ignore
import { ServiceProviderCaseResponsePagingResult } from '../models';
/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateTemplateByMechanic: async (messageTemplateDto?: MessageTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/TemplateMechanic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetTemplatesByMechanic: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/GetTemplatesByMechanic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list Service Case
         * @param {MessageFilter} [messageFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessageGetListCasePost: async (messageFilter?: MessageFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/getListCase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a specific message by messageId
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesByMessageIdDelete: async (messageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMessagesByMessageIdDelete', 'messageId', messageId)
            const localVarPath = `/api/messages/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markStar Update message status to read
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCaseMarkStar: async (caseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('apiMessagesCaseMarkStar', 'caseId', caseId)
            const localVarPath = `/api/messages/markStar/{caseId}`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark a message as unread
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCaseMarkUnread: async (messageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMessagesCaseMarkUnread', 'messageId', messageId)
            const localVarPath = `/api/messages/markUnread/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCreateMessagTemplatePost: async (messagePostPut?: MessagePostPut, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/createMessagTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagePostPut, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Message By Case
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesGetListByCase: async (caseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('apiMessagesGetListByCase', 'caseId', caseId)
            const localVarPath = `/api/messages/GetListMessageByCase/{caseId}`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPost: async (messagePostPut?: MessagePostPut, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagePostPut, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new message file
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPostFile: async (file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/uploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all messages of case
         * @param {number} caseId caseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesReadAllMessagesByCaseIdPut: async (caseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('apiMessagesReadAllMessagesByCaseIdPut', 'caseId', caseId)
            const localVarPath = `/api/messages/readAllMessages/{caseId}`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update message status to read
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesReadMessagesByMessageIdPut: async (messageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMessagesReadMessagesByMessageIdPut', 'messageId', messageId)
            const localVarPath = `/api/messages/readMessages/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SetReadUserIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesSetReadUserIdsPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/setReadUserIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRemoveTemplateByMechanic: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRemoveTemplateByMechanic', 'id', id)
            const localVarPath = `/api/messages/TemplateMechanic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateTemplateByMechanic: async (messageTemplateDto?: MessageTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/TemplateMechanic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAllTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/GetAllTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAllTemplateByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplateByUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/GetAllTemplateByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCreateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCreateTemplateByMechanic(messageTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetTemplatesByMechanic(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MessageTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetTemplatesByMechanic(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list Service Case
         * @param {MessageFilter} [messageFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessageGetListCasePost(messageFilter?: MessageFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderCaseResponsePagingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessageGetListCasePost(messageFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a specific message by messageId
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesByMessageIdDelete(messageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesByMessageIdDelete(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary markStar Update message status to read
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesCaseMarkStar(caseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesCaseMarkStar(caseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary mark a message as unread
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesCaseMarkUnread(messageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesCaseMarkUnread(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesCreateMessagTemplatePost(messagePostPut?: MessagePostPut, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesCreateMessagTemplatePost(messagePostPut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get List Message By Case
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesGetListByCase(caseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceProviderCaseMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesGetListByCase(caseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesPost(messagePostPut?: MessagePostPut, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesPost(messagePostPut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload new message file
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesPostFile(file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesPostFile(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Read all messages of case
         * @param {number} caseId caseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesReadAllMessagesByCaseIdPut(caseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesReadAllMessagesByCaseIdPut(caseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update message status to read
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesReadMessagesByMessageIdPut(messageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesReadMessagesByMessageIdPut(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SetReadUserIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesSetReadUserIdsPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesSetReadUserIdsPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRemoveTemplateByMechanic(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRemoveTemplateByMechanic(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateTemplateByMechanic(messageTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetAllTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTemplate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTemplate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetAllTemplateByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTemplateByUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTemplateByUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageApiFp(configuration)
    return {
        /**
         * 
         * @summary Create message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiCreateTemplateByMechanic(messageTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetTemplatesByMechanic(options?: any): AxiosPromise<Array<MessageTemplateDto>> {
            return localVarFp.apiGetTemplatesByMechanic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list Service Case
         * @param {MessageFilter} [messageFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessageGetListCasePost(messageFilter?: MessageFilter, options?: any): AxiosPromise<ServiceProviderCaseResponsePagingResult> {
            return localVarFp.apiMessageGetListCasePost(messageFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a specific message by messageId
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesByMessageIdDelete(messageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesByMessageIdDelete(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markStar Update message status to read
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCaseMarkStar(caseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesCaseMarkStar(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark a message as unread
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCaseMarkUnread(messageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesCaseMarkUnread(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesCreateMessagTemplatePost(messagePostPut?: MessagePostPut, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesCreateMessagTemplatePost(messagePostPut, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Message By Case
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesGetListByCase(caseId: number, options?: any): AxiosPromise<Array<ServiceProviderCaseMessage>> {
            return localVarFp.apiMessagesGetListByCase(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new message
         * @param {MessagePostPut} [messagePostPut] message info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPost(messagePostPut?: MessagePostPut, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesPost(messagePostPut, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new message file
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPostFile(file?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiMessagesPostFile(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all messages of case
         * @param {number} caseId caseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesReadAllMessagesByCaseIdPut(caseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesReadAllMessagesByCaseIdPut(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update message status to read
         * @param {number} messageId messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesReadMessagesByMessageIdPut(messageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesReadMessagesByMessageIdPut(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SetReadUserIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesSetReadUserIdsPut(options?: any): AxiosPromise<void> {
            return localVarFp.apiMessagesSetReadUserIdsPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRemoveTemplateByMechanic(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiRemoveTemplateByMechanic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update message template by mechanic
         * @param {MessageTemplateDto} [messageTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiUpdateTemplateByMechanic(messageTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAllTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplate(options?: any): AxiosPromise<void> {
            return localVarFp.getAllTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAllTemplateByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplateByUser(options?: any): AxiosPromise<void> {
            return localVarFp.getAllTemplateByUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI {
    /**
     * 
     * @summary Create message template by mechanic
     * @param {MessageTemplateDto} [messageTemplateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiCreateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiCreateTemplateByMechanic(messageTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiGetTemplatesByMechanic(options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiGetTemplatesByMechanic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list Service Case
     * @param {MessageFilter} [messageFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessageGetListCasePost(messageFilter?: MessageFilter, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessageGetListCasePost(messageFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a specific message by messageId
     * @param {number} messageId messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesByMessageIdDelete(messageId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesByMessageIdDelete(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markStar Update message status to read
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesCaseMarkStar(caseId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesCaseMarkStar(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark a message as unread
     * @param {number} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesCaseMarkUnread(messageId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesCaseMarkUnread(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new message
     * @param {MessagePostPut} [messagePostPut] message info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesCreateMessagTemplatePost(messagePostPut?: MessagePostPut, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesCreateMessagTemplatePost(messagePostPut, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Message By Case
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesGetListByCase(caseId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesGetListByCase(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new message
     * @param {MessagePostPut} [messagePostPut] message info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesPost(messagePostPut?: MessagePostPut, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesPost(messagePostPut, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new message file
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesPostFile(file?: any, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesPostFile(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all messages of case
     * @param {number} caseId caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesReadAllMessagesByCaseIdPut(caseId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesReadAllMessagesByCaseIdPut(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update message status to read
     * @param {number} messageId messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesReadMessagesByMessageIdPut(messageId: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesReadMessagesByMessageIdPut(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SetReadUserIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesSetReadUserIdsPut(options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesSetReadUserIdsPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiRemoveTemplateByMechanic(id: number, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiRemoveTemplateByMechanic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update message template by mechanic
     * @param {MessageTemplateDto} [messageTemplateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiUpdateTemplateByMechanic(messageTemplateDto?: MessageTemplateDto, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiUpdateTemplateByMechanic(messageTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAllTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public getAllTemplate(options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).getAllTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAllTemplateByUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public getAllTemplateByUser(options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).getAllTemplateByUser(options).then((request) => request(this.axios, this.basePath));
    }
}
